import moment from "moment";

export const renderYearsArrayBetweenStartDateAndNow = first => {
  const start = moment(first).year();
  const last = moment().year();
  const years = [];

  for (let i = start; i <= last; i++) {
    years.push(i);
  }
  return years;
};

export const renderYearsArrayBetween = (first, end) => {
  const start = moment(first).year();
  const last = moment(end).year();
  const years = [];

  for (let i = start; i <= last; i++) {
    years.push(i);
  }
  return years;
};

export const inIframe = () => {
  return window.location !== window.parent.location;
};

export const postMessage = (msg, evt) => {
  window.parent.postMessage(
    {
      message: msg,
      event: evt
    },
    "*"
  );
};



// WEBPACK FOOTER //
// ./src/utils/team.js